// extracted by mini-css-extract-plugin
module.exports = {"item":"TextItem__item--1kaF0","link":"TextItem__link--3XODN"};
    if(module.hot) {
      // 1605595233475
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  